export default {
	name: 'ClientFooter',
	props: {
		appLinks: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			appStoreLink: 'https://www.apple.com/ios/app-store/',
			googlePlayLink: 'https://play.google.com/store'
		}
	},
	methods: {
		contactUsEmail(){
			window.location.href = 'mailto:services@lovemydogclub.com.au';
		},
		contactUsPhone(){
			window.location.href='tel:1300 307039'
		}
	}
}